<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epig"> </p>
<p class="ep-bot"><span class="epub-i">His magic is performed with complete naturalness, its artistry that of the art that conceals art. The consummate skill and technique is there but it is never displayed; it is, on the contrary, so carefully hidden that the performer is applauded not for his nimble-fingered dexterity but because he has, with the effortless ease of a real magician, exhibited a feat of what must be real magic.</span></p>
<p class="epc"><span class="epub-i">—Jean Hugard and Frederick Braue, </span>Expert Card Technique,<span class="epub-i"> Third Edition</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?702bb99e